const cdn = 'https://misc.360buyimg.com/m/auction-my/images/';
const createUri = path => ({ uri: cdn + path });
module.exports = {
  back: createUri('back.png'),
  back_w: createUri('back_w.png'),
  more: createUri('more.png'),
  more_w: createUri('more_w.png'),
  webview_nav_message: createUri('webview_nav_message.png'),
  webview_nav_cart: createUri('webview_nav_cart.png'),
  webview_nav_home: createUri('webview_nav_home.png'),
  webview_nav_search: createUri('webview_nav_search.png'),
  webview_nav_share: {
    uri: 'https://img12.360buyimg.com/imagetools/jfs/t1/169024/27/13179/1238/6052f098E8cdee2e7/b6620cb73e8c412c.png'
  },
  webview_nav_feedback: { uri: 'https://img12.360buyimg.com/imagetools/jfs/t1/168661/31/13338/1281/6052f062E3a147c42/ab63dd34d7502d13.png'},
};
